import axios from 'axios'

const PostingServince = {
  async get (params = {}) {
    return axios.get('po/inter-warehouse-transfer/postings', { params })
  },

  async histories (params = {}) {
    return axios.get('po/reports/inter-warehouse-transfer/posting-histories', { params })
  },

  async show (id) {
    return axios.get(`po/inter-warehouse-transfer/postings/${id}`)
  },

  async post (params = {}) {
    return axios.post('po/inter-warehouse-transfer/postings', params)
  },

  async put (params = { id: '' }) {
    return axios.put(`po/inter-warehouse-transfer/postings/${params.id}`, params)
  },

  async delete (data = { id: '' }) {
    return axios.delete(`po/inter-warehouse-transfer/postings/${data.id}`, { data })
  }
}

export default PostingServince
